/** @format */

import { appCode, appName } from '../config';
import OOTBR_CONSTANTS from 'config';


import App from './App';
// const LazyApp = lazy(async () => await import(`./App`));

const getI18nResources = async (locale, fallbackLocale) => {
  const { loadI18nResources } = await import('./i18n/resource-resolver');
  return await loadI18nResources(locale, fallbackLocale);
};

const config = {
  id: appName,
  moduleName: appName,
  personaMapping: appName,
  routePrefix: appCode,
  personas: ['agent', 'messagingAgent', 'marketer', 'guest', 'admin', 'agentManager', appName],
  switcher: {
    control: `switcher-item-${appName}`,
    index: 61, // index on the left side panel should put us just after Manager Workspace
    // control: 'switcher-item-account-analytics',
    fontIconName: 'ico-arrow-left', // refers to icon class name in _le-icons.scss and uses character '1' within LEIcons. LEIcons is the WOFF font family located at /src/sass/fonts/LEIcons/Mercury.woff. Both are within the lp-vue-components repo.
    titleTranslationKey: 'general.title',
    tooltipTranslationKey: 'general.title',
  },
};

const getAppRoutes = () => [
  {
    path: `/${appCode}`,
  },
];

const registerAppComponent = async () => {
  const { createRoot } = await import('react-dom/client');
  // return { createRoot, element: <div style={{ height: '100vh', width: '100vw'}} > <LazyApp appName={appName} appCode={appCode}/></div> };
  return { createRoot, element: <App appName={appName} appCode={appCode} /> };
};

const applicationInit = async (leAppConfig) => {

  const { sessionManager } = window.LE;

  let userHasAccess = sessionManager.isLPA();
  const isAdmin = sessionManager.isAdmin();
  const isCampaignManager = sessionManager.isCampaignManager();
  const isAgentManager = sessionManager.isAgentManager();

  if (!userHasAccess) {
    userHasAccess = isAgentManager || isAdmin || isCampaignManager;
  }

  const hasReportCenterAccess = sessionManager.getFeatureProperty(OOTBR_CONSTANTS.AC_FEATURE_REPORT_CENTER_ACCESS) ? sessionManager.getFeatureProperty(OOTBR_CONSTANTS.AC_FEATURE_REPORT_CENTER_ACCESS).value.value : false;
  const hasGenerativeAIAccess =
    Boolean(sessionManager.getFeatureProperty(OOTBR_CONSTANTS.AC_FEATURE_GENERATIVE_AI_ACCESS)?.value?.value) ||
    Boolean(sessionManager.getFeatureProperty(OOTBR_CONSTANTS.AC_FEATURE_GENERATIVE_AI_ACCESS_PREVIEW)?.value?.value);

  const showApp = userHasAccess && (hasReportCenterAccess || hasGenerativeAIAccess);

  if (!showApp || leAppConfig == null) return {};

  const i18nResources = await getI18nResources(leAppConfig.locale, leAppConfig.fallbackLocale);
  const reactModule = await registerAppComponent();
  const routes = getAppRoutes();

  return {
    appId: appCode,
    routes,
    reactModule,
    ...i18nResources,
  };
};

const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath; // eslint-disable-line
};

export default { config, webpackPathInit, applicationInit };
